module.exports = __webpack_public_path__ + "static/media/insurance_item-05.9bade9f0.svg";